import { render, staticRenderFns } from "./ViewSidebar.vue?vue&type=template&id=72c8b47d"
import script from "./ViewSidebar.vue?vue&type=script&lang=js"
export * from "./ViewSidebar.vue?vue&type=script&lang=js"
import style0 from "./ViewSidebar.vue?vue&type=style&index=0&id=72c8b47d&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports